import * as Yup from "yup";

export const institutionAdminEditSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required."),
  last_name: Yup.string().required("Last name is required."),
  username: Yup.string().required("Username is required."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required."),
});

export const institutionAdminSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required."),
  last_name: Yup.string().required("Last name is required."),
  username: Yup.string().required("Username is required."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required."),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)/,
      "Password must contain at least one number and one special character"
    )
    .required("Password is required."),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  institution_id: Yup.string().required("Institution is required"),
});

export const institutionAdminResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)/,
      "Password must contain at least one number and one special character"
    )
    .required("Password is required."),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const institutionAdminAttachSchema = Yup.object().shape({
  institution_id: Yup.string().required("Institution is required"),
});
